import { SchedulesOnProfileComponent } from "./schedules-on-profile.component";
import { SchedulesOnProfileActionsModalComponent } from "./schedulesOnProfileActionsModal/schedules-on-profile-actions-modal.component";
export var SchedulesOnProfileModule = angular
    .module('schedulesOnProfile', [])
    .component(SchedulesOnProfileComponent.selector, SchedulesOnProfileComponent.component)
    .component(SchedulesOnProfileActionsModalComponent.selector, SchedulesOnProfileActionsModalComponent.component)
    .name;
//# sourceMappingURL=schedules-on-profile.module.js.map